module.exports = __webpack_public_path__ + "fonts/AvenirNext-Heavy.b0c3ac6f.ttf";